import React from "react";
import Title from "../title";
import Grid from "../Grid/grid";
import ContactForm from "../contact-form/contact-form";

function WorkCaseStudyContactUs() {
  return (
    <div className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-8 lg:p-16">
      <Grid size={100} direction="top-center" />
      <div className="z-10 flex justify-start items-start mb-12 w-full">
        <Title title="Get in touch" />
      </div>
      <div className="flex md:flex-row flex-col justify-center">
        <div className="flex flex-col items-start justify-center gap-5 md:w-1/2">
          <h2 className="md:text-4xl text-xl font-medium max-w-4xl">
            Have Project In Mind, Lets Discuss
          </h2>
          <p className="text-gray-500">
            Let’s turn your idea into a powerful digital solution. Whether
            starting fresh or scaling up, our team is ready to help. Get in
            touch today.
          </p>
        </div>
        <div className="mt-5 flex items-center justify-center md:w-1/2">
          <ContactForm
            title="Have a Project in Mind?"
            purpose="Project Consultation and Planning"
          />
        </div>
      </div>
    </div>
  );
}

export default WorkCaseStudyContactUs;
